(function ($, Drupal) {

  Drupal.behaviors.accordionToggle = {
    attach: function (context, settings) {

      $(".accordion--outer-wrapper", context).once("accordionClick").each(function () {
        $(document).ready(function () {
          var firstChild = $(".accordion")[0].children[0];
          firstChild.children[0].click();
          firstChild.children[1].children[0].children[0].children[0].children[0].click();
        });
      });

      if ($(".accordion__wrap").length) {

        $(document).off('click', '.accordion__heading').on('click', '.accordion__heading', function (e) {
          e.preventDefault();

          var $this = $(this);
          if ($(window).width() > 991) {
            if ($($this.parents('.accordion')).length > 1) {
              $('.accordion .accordion__heading').removeClass('active');
              $this.addClass('active');
              var title = $this.text();
              var description = $this.siblings('.accordion__data').find('> .accordion__text p').text();
              var subAccordionTemplate = "<div class='sub-accordion'><div class='sub__heading'><h3>" + title +
                "</h3></div><div class='sub__body'>" + description +
                "</div></div>";
              $('.accordion--outer-wrapper .basic__wrap').empty();
              $('.accordion--outer-wrapper .basic__wrap').append(subAccordionTemplate);
              $this.parents('.layout').find('.layout__region--second .basic__wrap').empty();
            } else {
              accordionToggle($this);
            }
          } else {
            accordionToggle($this);
          }
        });
      }

      function accordionToggle($this) {
        if ($this.parent().parent('.accordion').siblings('.accordion').find('.accordion__heading').hasClass('accordion__open')) {
          $this.toggleClass('accordion__open');
          $this.siblings('.accordion__data').slideToggle(350);
          $this.parent().parent().siblings('.accordion').find('.accordion__heading').removeClass('accordion__open');
          $this.parent().parent().siblings('.accordion').find('.accordion__data').slideUp(350);
        } else {
          $this.toggleClass('accordion__open');
          $this.siblings('.accordion__data').slideToggle(350);
          $this.parent().parent().find('accordion__heading').removeClass('accordion__open');
          $this.parent().parent().find('accordion__data').slideUp(350);
        }
      }
    }
  };
})(jQuery, Drupal);
